import React from 'react';
import { connect } from 'react-redux';

import SlidingSwitch from '../../../UI/SlidingSwitch/SlidingSwitch';

import { toggleRefundableFlights, toggleNonStopFlights, switchHeaderView } from '../../../../store/actions/index';

const flightHeaderQuickFilters = (props) => (
    <div className={`u-phoneShow u-flex u-backgroundColorWhite`}>
        <div className={`f-1 u-borderRightNormal u-textAlignLeft`}>
        <div className={`u-flex align-items-center justify-content-center u-height100Percent`}>
            <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize11`}>Non-Stop</p>
            <div className={`ml-2 u-lineHeight1`}>
                <SlidingSwitch onChange={() => props.onToggleNonStopFlights()} checked={props.selectedStops.includes(0) ? true : false} />
            </div>
        </div>
        </div>
        <div className={`f-1 u-borderRightNormal`}>
        <div className={`u-flex align-items-center justify-content-center u-height100Percent`}>
            <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize11`}>Refundable</p>
            <div className={`ml-2 u-lineHeight1`}>
                <SlidingSwitch onChange={() => props.onToggleRefundableFlights()} checked={props.refundableArray.includes(1) ? true : false} />
            </div>
        </div>
        </div>
        <div className={`f-1 u-textAlignCenter`}><span onClick={() => props.onSwitchHeaderView('filter')} className={`u-fontSize11 u-fontWeightMedium u-textColorPrimary u-textUppercase u-height100Percent`}>+ More Filters</span></div>
    </div>
);

const mapStateToProps = state => {
    return {
        refundableArray: state.flights.refundableArray,
        selectedStops: state.flights.selectedStops
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSwitchHeaderView: (view) => dispatch(switchHeaderView(view)),
        onToggleRefundableFlights: () => dispatch(toggleRefundableFlights()),
        onToggleNonStopFlights: () => dispatch(toggleNonStopFlights())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(flightHeaderQuickFilters);


// WEBPACK FOOTER //
// ./src/components/Flight/FlightHeader/FlightHeaderQuickFilters/FlightHeaderQuickFilters.js